import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lib-container-list-materials',
  templateUrl: './container-list-materials.component.html',
  styleUrls: ['./container-list-materials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContainerListMaterialsComponent {}
